module.exports = __webpack_public_path__ + "static/media/avolant.ce50d79a.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/papa/climasense/acaro_blanco_papa/curativa/avolant.png
// module id = 1986
// module chunks = 3